module.exports = __webpack_public_path__ + "img/Nalu-Pay-Logo.d7e681c2.svg";